// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"withAuthorization_pageHeading__3tFmW","notFoundIcon":"withAuthorization_notFoundIcon__22Akc"};